const DiscountType = {
  WithDiscount: "with-discount",
  WithoutDiscount: "without-discount",
  Outright: "outright",
};

export default DiscountType;
